import { connect } from 'react-redux';

import MenuItem from './desktop.menu.menu_item.jsx';

import {
  getATagProps,
  isExternalLink,
  doesOpenInNewTab
} from 'zoomforth_codesbane_viewer/lib/app_actions.js';

import {
  getLastClickedToplevelInternalLinkId
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  handleMenuItemPostClickBehavior
} from 'zoomforth_codesbane_viewer/action_creators/viewer.js';

const mapStateToProps = (state, { menuItem, selected }) => {
  const { href, target } = getATagProps(menuItem.appAction);
  const shouldShowExternalOpeningMsg = (
    isExternalLink(menuItem.appAction) || doesOpenInNewTab(menuItem.appAction)
  );

  const lastClickedToplevelInternalLinkId = getLastClickedToplevelInternalLinkId(state);

  // toplevel internal links should take precedence over a subpage link showing as selected
  var isSelected;
  if (lastClickedToplevelInternalLinkId) {
    isSelected = lastClickedToplevelInternalLinkId === menuItem.id;
  } else {
    isSelected = selected;
  }

  return {
    children: menuItem.title,
    menuItemId: menuItem.id,
    selected: isSelected,
    shouldShowExternalOpeningMsg,
    href,
    target
  };
};

const mapDispatchToProps = (dispatch, { menuItem, currentSubpage }) => ({
  onClick: () => {
    dispatch(handleMenuItemPostClickBehavior(menuItem, currentSubpage, { shouldScrollTopForPageChange:false }));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuItem);
